import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Sponsors: React.FC = () => {
  return (
    <Container className="py-5">
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold text-navy">Partner With Us</h1>
        <p className="lead text-muted">Help us make higher-level soccer available to more Central Iowa kids.</p>
        <hr className="w-25 mx-auto text-teal" style={{ opacity: 1, height: '3px' }} />
      </div>

      <Row className="align-items-center mb-5">
        <Col lg={6}>
          <h2 className="text-teal fw-bold mb-3">Why Sponsor 515 Soccer?</h2>
          <p className="fs-5">
            515 Soccer Academy is a 501(c)(3) non-profit organization dedicated to breaking down barriers in youth sports. 
            By eliminating tryouts and focusing on development, we serve hundreds of families in the Pleasant Hill, Altoona, and East Des Moines areas.
          </p>
          <p>
            Your sponsorship directly impacts our ability to:
          </p>
          <ul className="list-unstyled">
              <li className="mb-2"><span className="text-teal me-2">✔</span>Keep registration costs among the lowest in the metro.</li>
              <li className="mb-2"><span className="text-teal me-2">✔</span>Provide full financial aid scholarships to players in need.</li>
              <li className="mb-2"><span className="text-teal me-2">✔</span>Invest in high-quality equipment and coaching education.</li>
          </ul>
        </Col>
        <Col lg={6}>
           <div className="bg-light p-5 rounded shadow-sm text-center">
                <h3 className="fw-bold text-navy mb-4">Make an Impact</h3>
                <p>
                    Join local businesses and community leaders in supporting the next generation of athletes.
                </p>
                <Button href="mailto:info@515soccer.org?subject=Sponsorship Inquiry" variant="primary" size="lg" className="px-5">
                    Contact Us to Sponsor
                </Button>
           </div>
        </Col>
      </Row>

      <h2 className="text-center fw-bold text-navy mb-4">Sponsorship Opportunities</h2>
      <p className="text-center text-muted mb-5">We offer a wide range of packages to fit your budget and marketing goals.</p>

      <Row className="g-4 justify-content-center">
        {/* Jersey Sponsorship */}
        <Col md={6} lg={5}>
          <Card className="h-100 border-0 shadow-sm hover-shadow transition-all">
            <Card.Header className="bg-navy text-white text-center py-3">
                <h4 className="m-0 fw-bold">Jersey Sponsor</h4>
            </Card.Header>
            <Card.Body className="p-4 d-flex flex-column">
              <div className="text-center mb-4">
                 <span style={{fontSize: '3rem'}}>👕</span>
              </div>
              <Card.Title className="text-center fw-bold mb-3">Premier Visibility</Card.Title>
              <Card.Text className="text-center mb-4">
                Your logo prominently displayed on the front or back of our match jerseys. Worn by every player at every game, tournament, and event.
              </Card.Text>
              <ul className="list-unstyled small mb-4 mt-auto">
                  <li className="mb-2 border-bottom pb-2">Highest brand visibility</li>
                  <li className="mb-2 border-bottom pb-2">Multi-year partnership options</li>
                  <li className="mb-0">Social media & website features</li>
              </ul>
              <Button href="mailto:info@515soccer.org?subject=Jersey Sponsorship" variant="outline-primary" className="w-100">Inquire Now</Button>
            </Card.Body>
          </Card>
        </Col>

         {/* General/Field Sponsor */}
         <Col md={6} lg={5}>
          <Card className="h-100 border-0 shadow-sm hover-shadow transition-all">
            <Card.Header className="bg-light text-navy text-center py-3 border-bottom">
                <h4 className="m-0 fw-bold">Club Supporter</h4>
            </Card.Header>
            <Card.Body className="p-4 d-flex flex-column">
              <div className="text-center mb-4">
                 <span style={{fontSize: '3rem'}}>🤝</span>
              </div>
              <Card.Title className="text-center fw-bold mb-3">Community Partner</Card.Title>
              <Card.Text className="text-center mb-4">
                Perfect for local businesses wanting to show support. Includes website logo placement, social media shoutouts, and event recognition.
              </Card.Text>
              <ul className="list-unstyled small mb-4 mt-auto">
                  <li className="mb-2 border-bottom pb-2">Cost-effective entry point</li>
                  <li className="mb-2 border-bottom pb-2">Digital marketing benefits</li>
                  <li className="mb-0">Tax-deductible donation</li>
              </ul>
              <Button href="mailto:info@515soccer.org?subject=Club Sponsorship" variant="outline-primary" className="w-100">Inquire Now</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      <div className="text-center mt-5">
           <p className="text-muted">
               Have a unique idea? We are open to custom partnerships! 
               <Link to="/contact" className="ms-2">Contact us</Link> to discuss.
           </p>
      </div>
    </Container>
  );
};

export default Sponsors;
